/**
 * Same HTML body path as Company Microsoft Innhold:
 * raw Graph/HTML in a sandboxed iframe. Do not run the inbound sanitizer here —
 * that strips signature CSS, logos and quoted mail into a text blob.
 */
export function MailHtmlIframe({
  html,
  text,
  title,
  emptyLabel,
  iframeClassName = "h-[min(55vh,520px)] w-full border-0",
}) {
  const srcDoc = html == null ? "" : String(html);
  if (srcDoc.trim()) {
    return (
      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
        <iframe
          title={title}
          sandbox=""
          className={iframeClassName}
          srcDoc={srcDoc}
        />
      </div>
    );
  }

  const plain = text == null ? "" : String(text);
  if (plain.trim()) {
    return (
      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
        <pre className="max-h-[min(55vh,520px)] overflow-auto whitespace-pre-wrap break-words p-3 font-sans text-sm text-gray-800">
          {plain}
        </pre>
      </div>
    );
  }

  if (emptyLabel) {
    return <p className="text-sm text-gray-600">{emptyLabel}</p>;
  }

  return null;
}
